import React, { useState } from 'react';
import { GitHub } from 'react-feather';

export default function GitHubLogin() {
  const [employeeName, setEmployeeName] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!employeeName.trim()) {
      setError('Please enter your full name');
      return;
    }

    // Store the name in session storage for use after GitHub callback
    sessionStorage.setItem('employeeName', employeeName.trim());
    
    // Fetch GitHub auth URL and redirect
    try {
      const response = await fetch('https://api.usepeppr.ai/api/github/auth', {
        credentials: 'include',
        headers: {
          'X-Employee-Name': employeeName.trim()
        }
      });
      const data = await response.json();
      console.log(data);
      if (!data.auth_url) {
        throw new Error('No authentication URL received');
      }
      window.location.href = data.auth_url;
    } catch (err) {
      setError('Failed to start authentication');
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="w-full max-w-xs">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Full Name
        </label>
        <input
          type="text"
          value={employeeName}
          onChange={(e) => setEmployeeName(e.target.value)}
          placeholder="Enter your full name"
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-black"
        />
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
      
      <button
        onClick={handleLogin}
        disabled={!employeeName.trim()}
        className={`flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#24292F] hover:bg-[#24292F]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#24292F] ${
          !employeeName.trim() ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <GitHub className="w-5 h-5 mr-2" />
        Sign in with GitHub
      </button>
    </div>
  );
} 